import { render, staticRenderFns } from "./ChannelOverallChart.vue?vue&type=template&id=190e562d&scoped=true"
import script from "./ChannelOverallChart.vue?vue&type=script&lang=js"
export * from "./ChannelOverallChart.vue?vue&type=script&lang=js"
import style0 from "./ChannelOverallChart.vue?vue&type=style&index=0&id=190e562d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e562d",
  null
  
)

export default component.exports